import * as React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { mergeProps, isOnlyChildClonable } from '../../utils/react.js';
import { getError, mapProps } from '../Form/formUtils.js';
import { FormField, defaultElement } from '../FormField/FormField.js';
import { jsx } from 'react/jsx-runtime';

var FormControl = /*#__PURE__*/React.forwardRef(function FormControl2(props, ref) {
  var _props$as = props.as,
    as = _props$as === void 0 ? defaultElement : _props$as,
    _children = props.children,
    className = props.className,
    controlIdProp = props.controlId,
    description = props.description,
    _props$formId = props.formId,
    formId = _props$formId === void 0 ? "form-1" : _props$formId,
    inline = props.inline,
    label = props.label,
    labelProps = props.labelProps,
    name = props.name,
    success = props.success,
    validation = props.validation;
  var context = useFormContext();
  if (!context) {
    throw new TypeError("No FormContext provided to FormControl with 'props.name': '".concat(name, "'"));
  }
  var control = context.control,
    disableAll = context.disableAll,
    formState = context.formState,
    inlineAll = context.inlineAll;
  var error = getError(formState, name);
  return /*#__PURE__*/jsx(FormField, {
    as: as,
    className: className,
    controlId: controlIdProp,
    description: description,
    error: error,
    formId: formId,
    inline: typeof inline === "boolean" ? inline : inlineAll,
    label: label,
    labelProps: labelProps,
    ref: ref,
    required: !!(validation !== null && validation !== void 0 && validation.required),
    success: success,
    children: function children(controlId) {
      return /*#__PURE__*/jsx(Controller, {
        control: control,
        name: name,
        rules: validation,
        render: function render(_ref) {
          var field = _ref.field;
          var newProps = mergeProps({
            id: controlId,
            error: !!error,
            disabled: disableAll
          }, mapProps(field));
          if (typeof _children === "function") return _children(newProps);
          if (isOnlyChildClonable(_children)) {
            newProps.disabled = typeof _children.props.disabled === "boolean" ? _children.props.disabled : newProps.disabled;
            return /*#__PURE__*/React.cloneElement(_children, newProps);
          }
          return _children;
        }
      });
    }
  });
});
FormControl.displayName = "FormControl";

export { FormControl };
